// @ToDo: Import AWS Amplify User type and get rid of 'any' type
// import { CognitoUser } from '@aws-amplify/auth';

export const getRole = (user: any) => {
  if (user !== undefined && user.attributes !== undefined) {
    return user.attributes["custom:nostra-user-role"];
  }
  return "";
};
